/** Skin colour palette — mirrors iOS `SkinColor` enum (SkinColor.swift). */
export const SKIN_COLORS = [
  '#432D1E',
  '#644029',
  '#7F5633',
  '#96653A',
  '#BB8052',
  '#DDA679',
  '#EDC391',
  '#F4CBA7',
  '#F5D4B4',
] as const;

export type SkinColorHex = (typeof SKIN_COLORS)[number];
